require("../coord/parallel/parallelCreator");

require("./axis/parallelAxisAction");

require("./axis/ParallelAxisView");


//////////////////
// WEBPACK FOOTER
// ../~/echarts/lib/component/parallelAxis.js
// module id = 4x7Y
// module chunks = 0